(function () {
  function addToCart(variantId, button) {
    button.disabled = true;
    button.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return refreshCart();
      })
      .then(function () {
        button.textContent = 'Added ✓';
      })
      .catch(function () {
        button.textContent = 'Try again';
        button.disabled = false;
      });
  }

  function swapAllPresent(doc, selector) {
    var oldEls = document.querySelectorAll(selector);
    var newEls = doc.querySelectorAll(selector);
    for (var i = 0; i < oldEls.length && i < newEls.length; i++) {
      oldEls[i].replaceWith(newEls[i]);
    }
  }

  function refreshCart() {
    // Haalt de huidige pagina opnieuw op (server-side, dus altijd correct)
    // en vervangt alleen de relevante stukjes: cart-items, subtotaal,
    // upsell-blok(ken) en verzendbalk. Werkt zowel in de drawer als op de
    // cart-pagina, zonder de open/dicht-status van de drawer te verstoren.
    return fetch(window.location.pathname + window.location.search)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        swapAllPresent(doc, '#CartDrawer-CartItems');
        swapAllPresent(doc, '.cart-drawer__footer');
        swapAllPresent(doc, '[data-cart-upsell]');
        swapAllPresent(doc, '#free-shipping-bar');
        swapAllPresent(doc, '#main-cart-items');
        swapAllPresent(doc, '#main-cart-footer');
      })
      .catch(function () {
        // Kon niet live verversen: val terug op een volledige herlaad.
        window.location.reload();
      });
  }

  // Eén gedelegeerde click-listener op document i.p.v. losse listeners per
  // knop: die blijft ook werken nadat het thema zelf de cart-inhoud ververst
  // (want dan bestaat de knop opnieuw, maar met dezelfde class).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cart-upsell__add');
    if (btn) addToCart(btn.getAttribute('data-variant-id'), btn);
  });
})();